import { render } from "./TransitionSlide.vue?vue&type=template&id=47a63ba2&scoped=true&ts=true"
import script from "./TransitionSlide.vue?vue&type=script&lang=ts"
export * from "./TransitionSlide.vue?vue&type=script&lang=ts"

import "./TransitionSlide.vue?vue&type=style&index=0&id=47a63ba2&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a63ba2"]])

export default __exports__